export default {
      id: "loader-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.svg#loader",
      toString: function () {
        return this.url;
      }
    }